import { ReactNode } from 'react';
import { observer } from 'mobx-react-lite';

import { TNotification } from '../../core/notifications';
import { Notifications, useNotify } from '../notifications';

type PageNotificationsRenderProps = {
  children?: (notifications: ReactNode) => ReactNode;
};

export const PageNotificationsRender = observer(
  ({ children }: PageNotificationsRenderProps) => {
    const notifications = useNotify();
    const hasNotifications = notifications.messages.length > 0;

    const onClose = (messageId: Pick<TNotification, 'id'>) =>
      notifications.removeMessage(messageId);

    return hasNotifications ? (
      <>
        {children ? (
          children(
            <Notifications
              messages={notifications.messages}
              onClose={onClose}
            />,
          )
        ) : (
          <Notifications messages={notifications.messages} onClose={onClose} />
        )}
      </>
    ) : null;
  },
);
